<template>
  <div
    :style="{
      width: cardSizeReactive[0] - 2 + 'px',
      height: cardSizeReactive[1] - 2 + 'px',
    }"
    style="border: 1px grey solid"
  >
    <h1 class="agent-name flex">
      <span style="font-weight: 700" v-multi-ref:resize>{{
        removeDot(agent.agentName).toUpperCase()
      }}</span>
    </h1>

    <h1 class="break-reason flex">
      <span v-multi-ref:resize>{{ getBreakReason(agent.breakReason) }}</span>
    </h1>

    <h1 class="agent-time flex">
      <span v-multi-ref:resize>{{ toHMS(timeInState) }}</span>
    </h1>
  </div>
</template>

<script>
export default {
  props: {
    agentInfo: Object,
    cardSize: Array,
  },

  watch: {
    cardSizeReactive() {
      this.$nextTick(() => {
        this.resizeText({
          elements: this.$refs.resize,
        });
      });
    },
  },

  computed: {
    agent() {
      return this.agentInfo;
    },

    cardSizeReactive() {
      return this.cardSize;
    },

    timeInState() {
      var date = new Date(Date.parse(this.agent.timestampCurrentState));
      var diff = this.now - date;
      return diff;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.resizeText({
        elements: this.$refs.resize,
      });
    });
  },

  methods: {
    removeDot(name) {
      return name.replaceAll(".", " ");
    },

    getBreakReason(reason) {
      var reasonStr = this.$diamond.breakReasons[reason];
      if (reasonStr === undefined)
        return `Unknown Break Reason code: ${reason}`;
      return reasonStr;
    },
  },
};
</script>

<style scoped>
.agent-card {
  border: 1px solid rgba(0, 0, 0, 0.3);
  margin: 0;
  padding: 0;
  text-align: center;
}

.body {
  height: 100%;
  margin: 5px 0;
}

.agent-name{
  height:35%;
}

.break-reason{
  height: 30%;
}

.agent-time{
  height:35%;
}

.flex{
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  width:100%
}
</style>
